import classes from './login-box.module.css';

const LoginBox:React.FC<{children?: React.ReactNode} > = (props) => {


  return (
<div className={classes.Box}> {props.children}
   </div>

  );
}

export default LoginBox;